// src/components/KeywordTag.jsx
export default function KeywordTag({ keyword }) {
  return (
    <span className="bg-blue-100 text-blue-800 text-xs font-medium px-3 py-1 rounded-full">
      {keyword}
    </span>
  );
}
